// extracted by mini-css-extract-plugin
module.exports = {"postSizeXS":"PostSizeXS_postSizeXS__1hwEc","image":"PostSizeXS_image__2B5n5","text":"PostSizeXS_text__3Eu1f","title":"PostSizeXS_title__3vXlk","novo":"PostSizeXS_novo__9T9sK"};